export default __webpack_public_path__ + "static/media/donations2.b921e56a.jpg";